module.exports = __webpack_public_path__ + "img/icon-close-squared.50cd3957.svg";